import React, {useEffect, useState, useContext, useRef} from "react";
import styles from "./caseAttributesFilterPicker/CaseAttributesFilterPicker.module.scss";
import Button from "../../../../Componnets/Button/Button";
import appContext from "../../../../../context/appContext";
import MainDropdown from "../../../../Componnets/MainDropdown/MainDropdown";
import Input from "../../../../Componnets/Input/Input";
import http from "../../../../../services/api/utilities/http";

const CaseAttributesFilterPicker = ({ title, selectedItems, handleSubmitFilters, handleAddNewFilter, themeColor }) => {

  const [isOpenDropDown, setIsOpenDropDown] = useState(false);
  const [columns, setColumns] = useState(null);
  const [dropDownValue, setDropDownValue] = useState(null);
  const [typeOfSelectedItem, setTypeOfSelectedItem] = useState(null);
  const [attributeInfo, setAttributeInfo] = useState(null);
  const [filteredAttributeInfo, setFilteredAttributeInfo] = useState(null);
  const [selectedOperand, setSelectedOperand] = useState(null);
  const [selectedAttributeInfo, setSelectedAttributeInfo] = useState([]);
  const [selectedFilterData, setSelectedFilterData] = useState(selectedItems || []);
  const [dropdownValues, setDropdownValues] = useState([]);
  const [operators, setOperators] = useState(null);
  const [isNumericValues, setIsNumericValues] = useState(false)
  const context = useContext(appContext);
  const el = useRef(null);

  useEffect(() => {
    if (!selectedItems || !selectedItems.length) {
      handleSubmitFilters([{column: ["Column"], value: ["Value"], is_active: true}]);
    }
    setSelectedOperand(null);
    setSelectedAttributeInfo([]);
    setAttributeInfo(null);
    setFilteredAttributeInfo(null);
    setDropDownValue(null);
  }, []);

  useEffect(() => {
    if ((!selectedFilterData || !selectedFilterData.length || !selectedFilterData.find(item => item.column[0] === dropDownValue))) {
      if (selectedFilterData.length && !selectedFilterData.find(item => item.column[0] === dropDownValue) && selectedFilterData[selectedFilterData.length - 1].column[0] !== "Column") {
        const lastItem = selectedFilterData[selectedFilterData.length - 1];
        setSelectedOperand(lastItem && lastItem.operand[0]);
        setSelectedAttributeInfo(lastItem.value);
        setAttributeInfo(null);
        setFilteredAttributeInfo(null);
        setDropDownValue(lastItem.column[0]);
      } else {
        setSelectedOperand(null);
        setSelectedAttributeInfo([]);
        setAttributeInfo(null);
        setFilteredAttributeInfo(null);
        setDropDownValue(null);
      }
    }
    if (selectedFilterData.length && selectedFilterData[selectedFilterData.length - 1].column[0] === "Column") {
      setDropDownValue(null);
      setSelectedOperand(null);
      setSelectedAttributeInfo([]);
    }
  }, [selectedFilterData]);

  useEffect(() => {
    if (dropDownValue && columns) {
      setTypeOfSelectedItem(columns[dropDownValue]);
    }
  }, [dropDownValue, columns]);

  const getAvailableAttributes = () => {
    http.get('process_mining/attribute_search/' + context.handleUid().id)
      .then(res => {
        const columns = res.data.data;
        setColumns(columns);
        const values = columns && Object.entries(columns).filter(([key, value]) => {
          return key !== 'CASEID' && key !== 'STARTTIME' && key !== 'ENDTIME' && key !== 'ACTIVITY' && key !== 'TIMESTAMP' && !key.includes('timestamp')
        })
        setDropdownValues(values);
      })
      .catch(err=>{
        console.log(err.response);
      })
  }

  const getAttributeInfo = () => {
      http.post('process_mining/attribute_search/' + context.handleUid().id,
      {
        field: dropDownValue
      })
      .then(res => {
        setAttributeInfo(res.data.data.result);
      })
      .catch(err=>{
        console.log(err.response);
      })
  }

  useEffect(() => {
    setFilteredAttributeInfo(attributeInfo);
  }, [attributeInfo]);

  useEffect(() => {
    getAvailableAttributes();
  }, []);

  const handleDropDownOnClick = (value) => {
    const findItem = selectedFilterData.find((item, index) => index === selectedFilterData.length - 1);
    if (dropDownValue) {
      const filtered = selectedFilterData.filter((item, index) => index !== selectedFilterData.length - 1);
      setSelectedFilterData([...filtered, {...findItem, column: [value], value: ["Value"], is_active: true}]);
    } else {
      setSelectedFilterData([...selectedFilterData, {column: [value], value: ["Value"], is_active: true}]);
    }
    setDropDownValue(value);
    setIsOpenDropDown(false);
  }

  useEffect(() => {
    if (selectedFilterData.length !== 0) {
      const foundData = selectedFilterData.find((item, index) => selectedFilterData.length - 2 === index);
      if (foundData) {
        if (!foundData['column'] || !foundData['operand'] || !foundData['value']) {
          const filteredData = selectedFilterData.filter((item, index) => selectedFilterData.length - 2 !== index);
          setSelectedFilterData(filteredData)
        }
      }
    }
  }, [dropDownValue]);

  useEffect(() => {
    if (dropDownValue) {
      getAttributeInfo();
    }
  }, [dropDownValue]);

  useEffect(() => {
    if (dropDownValue && typeOfSelectedItem) {
      setIsNumericValues(typeOfSelectedItem === "integer" || typeOfSelectedItem === "float")
    }
  }, [dropdownValues, typeOfSelectedItem])

  const handleTriggerOpenDropDown = () => {
    setIsOpenDropDown(!isOpenDropDown);
  }

  const handleScroll = (direction) => {
    if (direction === 'right') {
      if (el) {
        el.current.scrollLeft += 100
      }
    } else if (direction === 'left') {
      if (el) {
        el.current.scrollLeft -= 100
      }
    }
  }

  const handleSetOperand = (operand) => {
    if (dropDownValue) {
      setSelectedOperand(operand);
      const findItem = selectedFilterData.find(item => item.column[0] === dropDownValue);
      const filteredData = selectedFilterData.filter(item => item.column[0] !== dropDownValue);
      setSelectedFilterData([...filteredData, {...findItem, operand: findItem.value.length ? findItem.value.map(item => operand) : [operand]}]);
    }
  }

  const isInteger = (value) => {
    if (typeof value !== 'string') {
      return false;
    }

    const num = Number(value);

    if (Number.isInteger(num)) {
      return true;
    }

    return false;
  }
  const handleSetAttributeInfo = (info, secondValue) => {
    let stringValue = info
    if(isInteger(info)) {
      stringValue = Number(info)
    }
    const findItem = selectedFilterData.find(item => item.column[0] === dropDownValue);
    let filteredData = selectedFilterData.filter(item => item.column[0] !== dropDownValue);
    const val = findItem && findItem.value;

    let passNewValue = [];
    let filtered;
    if (typeOfSelectedItem === "float" || typeOfSelectedItem === "integer") {
      passNewValue = [Number(info)]
    } else {
      if (val.some(item => item === stringValue)) {
        passNewValue = val.filter(item => item !== stringValue && item !== "Value");
      } else {
        passNewValue = [...val.filter(item => item !== "Value"), stringValue];
      }
    }

    const selectedOperand = findItem.operand?.[0]?.toLowerCase()

    if (passNewValue.length) {
      filtered = [...filteredData, {
        ...findItem,
        column: passNewValue.map(item => findItem.column[0]),
        operand: selectedOperand === "between" ? ["between"] : passNewValue.map(item => findItem.operand[0]),
        value: selectedOperand === "between" ?
          secondValue ?
            [typeof findItem?.value?.[0] === "string" ? `${findItem?.value?.[0]?.split(",")?.[0] || 0},${passNewValue[0]}` : `${findItem?.value?.[0] || 0},${passNewValue[0]}`]
            : typeof findItem?.value?.[0] === "string" ? [`${passNewValue[0]},${findItem?.value?.[0]?.split(",")?.[1] || 0}`] : [`${passNewValue[0]},0`]
          : passNewValue
      }];
    } else {
      filtered = [...filteredData, {...findItem, column: findItem.column, operand: findItem.operand, value: ["Value"]}]
    }

    setSelectedFilterData(filtered);
    setSelectedAttributeInfo(selectedOperand === "between" ?
      secondValue ?
        [typeof findItem?.value?.[0] === "string" ? `${findItem?.value?.[0]?.split(",")?.[0] || 0},${passNewValue[0]}` : `${findItem?.value?.[0] || 0},${passNewValue[0]}`]
        : typeof findItem?.value?.[0] === "string" ? [`${passNewValue[0]},${findItem?.value?.[0]?.split(",")?.[1] || 0}`] : [`${passNewValue[0]},0`]
      : passNewValue)
  }

  useEffect(() => {
    if (selectedAttributeInfo && selectedOperand && dropDownValue) {
      clearTimeout(window.typingTimer);
      window.typingTimer = setTimeout(() => addFilterToList(), 1000);
    }
  }, [selectedAttributeInfo, selectedOperand, dropDownValue]);

  const addFilterToList = () => {
    const valid = checkValidFilter();
    if (valid) {
      handleSubmitFilters(selectedFilterData);
    }
  }

  const handleAddNew = () => {
    handleAddNewFilter("addMore", "caseAttributes");
    setDropDownValue(null);
    setSelectedOperand(null);
    setSelectedAttributeInfo([]);
  }

  useEffect(() => {
    setSelectedFilterData(selectedItems);
  }, [selectedItems]);

  const checkValidFilter = () => {
    if (!selectedOperand || !selectedAttributeInfo) {
      alert("Please Select All Filter Items!");
      return false;
    } else {
      return true
    }
  }

  const handleChangeInputValue = (e) => {
    if (e.target.value.length !== 0) {
      if (attributeInfo) {
        const filtered = attributeInfo.filter(attribute => attribute.toLowerCase().includes(e.target.value.toLowerCase()));
        if (!filtered || filtered.length === 0) {
          setFilteredAttributeInfo(["Nothing Found!"]);
        } else {
          setFilteredAttributeInfo(filtered);
        }
      }
    } else {
      setFilteredAttributeInfo(attributeInfo)
    }
  }

  useEffect(() => {
    if (dropDownValue && typeOfSelectedItem) {
      if ((typeOfSelectedItem === 'int' || typeOfSelectedItem === 'float' || typeOfSelectedItem === 'datetime') || typeOfSelectedItem === "integer") {
        const operators = ['<', '>=', '>', '=', '<='];
        setOperators(operators)
      } else if (typeOfSelectedItem === 'str' || typeOfSelectedItem === 'string') {
        const operators = ['contains', 'starts_with', 'ends_with'];
        setOperators(operators)
      }
    }
  }, [dropDownValue, typeOfSelectedItem])

  useEffect(() => {
    if (operators) {
      handleSetOperand(operators[0])
    }
  }, [operators])

  return (
    <div className={[styles.CaseAttributesFilterPicker].join(' ')}>
      <div className={styles.contentsHeader}>
        { title }
      </div>
      <div className={['container-fluid', styles.fullHeight].join(' ')}>
        <div className={[styles.contentsBody, 'row'].join(' ')}>
          <div className={['col-sm-12 p-0', styles.fullHeight].join(' ')}>
            <div className={'row'}>
              <div className={[!isNumericValues ? 'col-sm-4' : 'col-sm-3 pr-0', styles.filterOption].join(' ')}>
                <div>
                  Attributes
                </div>
                <div onClick={handleTriggerOpenDropDown} onBlur={() => setIsOpenDropDown(false)} tabIndex={-1} className={styles.customSelectWrapper}>
                  <div className={[styles.customSelect, (isOpenDropDown ? styles.open : null)].join(' ')}>
                    <div className={styles.customSelect__trigger}><span>{ dropDownValue || 'Select an Item' }</span>
                      <div className={[styles.arrow, (isOpenDropDown ? styles.open : null)].join(' ')}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15.8332 7.08334L9.99984 12.9167L4.1665 7.08334" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                    <div className={styles.customOptions}>
                      {
                        (columns && dropdownValues.length > 0) && dropdownValues.map(item => (
                          <span
                            onClick={() => handleDropDownOnClick(item[0])}
                            className={[
                              styles.customOption,
                              (selectedItems.find(i => i.column[0] === item[0]) ? styles.disabled : ''),
                            ].join(' ')}
                            data-value={item[0]}
                          >
                            { item[0] }
                          </span>
                        ))
                      }
                      {
                        (columns && !dropdownValues.length) && <span className={styles.customOption}>No Data...</span>
                      }
                      {
                        !columns && <span className={styles.customOption}>Loading...</span>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className={[!isNumericValues ? 'col-sm-4' : 'ml-3 mr-3 pr-0', styles.filterOption].join(' ')} style={{width: isNumericValues && 126}}>
                <div>Operators</div>
                {
                  !isNumericValues
                    ? <div className={'d-flex'}>
                      {
                        operators?.length
                          ? operators?.map(operand => (
                            <div className={'mr-2'}>
                              <Button
                                onClick={() => handleSetOperand(operand)}
                                size={'small'}
                                type={'secondary'}
                                title={operand.replace( /([A-Z])/g, " $1" ).charAt(0).toUpperCase() + operand.replace( /([A-Z])/g, " $1" ).slice(1).replace("_", " ")}
                                active={operand === selectedOperand}
                                activeColor={themeColor ? themeColor : "#8a0fff"}
                              />
                            </div>
                          ))
                          : <div className={[styles.selectOperand, 'mt-0'].join(' ')}>
                            Select an Attribute
                          </div>
                      }
                    </div>
                    : <div>
                      <MainDropdown onChange={handleSetOperand} options={[...operators, "Between"]} placeholder={"Operator"} value={selectedOperand} />
                    </div>
                }
              </div>
              <div className={[!isNumericValues ? 'col-sm-4' : 'col-sm-7 pl-0', styles.filterOption].join(' ')}>
                <div>Value</div>
                {
                  !isNumericValues
                    ? <div className={styles.values}>
                        {selectedAttributeInfo.length > 0 ? selectedAttributeInfo[selectedAttributeInfo.length - 1] : <span>Select from bottom list</span>}
                      </div>
                    : <div className={'d-flex align-items-end'}>
                      <Input onChange={(e) => handleSetAttributeInfo(e.target.value)} value={(selectedOperand?.toLowerCase() === "between" && typeof selectedAttributeInfo[0] === "string") ? selectedAttributeInfo[0]?.split(",")?.[0] : selectedAttributeInfo[0]} placeholder={"Enter Value Here..."} isNumeric={true} />
                      {
                        selectedOperand === "Between" &&
                          <>
                            <span className={['ml-2 mr-2', styles.andSign].join(' ')}> & </span>
                            <Input onChange={(e) => handleSetAttributeInfo(e.target.value, true)} value={selectedOperand?.toLowerCase() === "between" && typeof selectedAttributeInfo[0] === "string" ? selectedAttributeInfo[0]?.split(",")?.[1] : selectedAttributeInfo[1]} placeholder={"Enter Value Here..."} isNumeric={true} />
                          </>
                      }
                    </div>
                }
              </div>
            </div>
            {
              !isNumericValues
                && <div className={['row', styles.fullHeight].join(' ')}>
                  <div className={[styles.attributesSection, styles.fullHeight, 'col-sm-12'].join(' ')}>
                    <div className={styles.title}>
                      {dropDownValue}
                    </div>
                    <div className={'row mt-3'}>
                      <div className={'col-sm-3'}>
                        <input type={'text'} placeholder={'Search'} onChange={handleChangeInputValue}/>
                      </div>
                      <div
                        className={[styles.scrollButtons, 'col d-flex align-items-center justify-content-end'].join(' ')}>
                        <div onClick={() => handleScroll('left')}
                             className={'d-flex justify-content-center align-items-center'}>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.9165 15.8333L7.08317 10L12.9165 4.16667" stroke="#0A195C" stroke-width="1.5"
                                  stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                        <div onClick={() => handleScroll('right')}
                             className={'d-flex justify-content-center align-items-center ml-2'}>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.0835 4.16666L12.9168 9.99999L7.0835 15.8333" stroke="#0A195C" stroke-width="1.5"
                                  stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div ref={el}
                         className={[styles.attributeItemsWrapper, styles.fullHeight, 'col-sm-12 p-0 mt-3 align-content-start'].join(' ')}>
                      {
                        selectedOperand ? filteredAttributeInfo && filteredAttributeInfo.map(item => (
                          <span
                            onClick={() => handleSetAttributeInfo(item)}
                            title={styles.attributeItem}
                            className={[styles.attributeItem, (selectedAttributeInfo.some(i => i === item) ? styles.selected : null)].join(' ')}
                            style={{color: selectedAttributeInfo.some(i => i === item) && themeColor && themeColor}}
                          >
                          {item}
                        </span>
                        )) : <span className={styles.selectOperand}>Please Select an Attribute and Operator ...</span>
                      }
                    </div>
                  </div>
                </div>
            }
          </div>
        </div>
        <div className={[styles.buttons, 'd-flex'].join(' ')}>
          <div className={'mr-2'}>
            <Button
              onClick={handleAddNew}
              title={'Add More'}
              color={context?.handleLayerList().find(item => item.selected)?.color}
              type={'outline'}
              size={'block'}
              height={"medium"}
            />
          </div>
        </div>
      </div>
    </div>
  )
};

export default CaseAttributesFilterPicker;